/**
 * Short supplier-bill description for Billing & Payables list cells.
 * Long invoice / contract / address detail belongs in notes.
 */

export const SUPPLIER_BILL_DESCRIPTION_MAX_LEN = 60;

export function capSupplierBillDescription(raw: string): {
  description: string;
  overflow: string;
} {
  const trimmed = String(raw || '').trim().replace(/\s+/g, ' ');
  if (trimmed.length <= SUPPLIER_BILL_DESCRIPTION_MAX_LEN) {
    return { description: trimmed, overflow: '' };
  }
  const slice = trimmed.slice(0, SUPPLIER_BILL_DESCRIPTION_MAX_LEN);
  const lastSpace = slice.lastIndexOf(' ');
  const cut = lastSpace >= 40 ? lastSpace : SUPPLIER_BILL_DESCRIPTION_MAX_LEN;
  const description = trimmed.slice(0, cut).trimEnd();
  const overflow = trimmed.slice(cut).trim();
  return { description, overflow };
}
